import type React from "react";

export default function Table({
	className,
	children,
	...props
}: { className?: string; children?: React.ReactNode }) {
	return (
		<table className={`${className} border-spacing-0 w-full`} {...props}>
			{children}
		</table>
	);
}

Table.Head = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<thead className={className} {...props}>
		{children}
	</thead>
);

Table.Body = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<tbody className={className} {...props}>
		{children}
	</tbody>
);

Table.Foot = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<tfoot className={className} {...props}>
		{children}
	</tfoot>
);

Table.TH = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<th className={className} {...props}>
		{children}
	</th>
);

Table.TR = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<tr className={className} {...props}>
		{children}
	</tr>
);

Table.TD = ({
	className,
	children,
	...props
}: { className?: string; children: React.ReactNode }) => (
	<td className={className} {...props}>
		{children}
	</td>
);
